import { getPropertyURL } from "@/utils/propertyNavigation";
import { Button, Card } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router";

const FailedMsg = ({ errorCardMsg, setErrorCardMsg, paymentFlag }) => {
  // console.log("errorCardMsg", errorCardMsg);
  const data = useSelector(
    (state) => state?.propertyDetail.getPropertyDetail
  );
  const navigate = useNavigate();
  const handlegetBidPageDetail = () => {
    if(paymentFlag) {
      navigate(`/my-shopper/myBids`); // for winning bidder CIF case
    } else {
      navigate(getPropertyURL(`/property/${data?.propertyDetails?.propertyId}`, data?.propertyDetails?.commonAttributes?.propCategory, data?.propertyDetails?.commonAttributes?.status));
    }
  };
  return (
    <>
      <Card className="text-center container bid-deposit-card">
        <Card.Body>
          <Card.Title className="failure_msg" style={{ color: "red" }}>
            <div className="heading-img mb-3">
              <svg
                version="1.0"
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                x="0px"
                y="0px"
                viewBox="0 0 24 24"
                style={{
                  enableBackground: "new 0 0 24 24",
                  height: "60px",
                  width: "60px",
                }}
              >
                <g>
                  <path
                    style={{ fill: "#d13b3b" }}
                    d="M12,1.01c-6.07,0-11,4.93-11,11s4.93,11,11,11c6.07,0,11-4.93,11-11S18.07,1.01,12,1.01L12,1.01z M12,22.16
              c-5.6,0-10.15-4.55-10.15-10.15C1.85,6.41,6.4,1.86,12,1.86c5.6,0,10.15,4.55,10.15,10.15C22.15,17.61,17.6,22.16,12,22.16
              L12,22.16z M12,22.16"
                  />
                </g>
                <g>
                  <g>
                    <path
                      style={{ fill: "#d13b3b" }}
                      d="M7.72,16.51l8.82-8.82l-0.73-0.73L7,15.73 M18,11.05"
                    />
                  </g>
                  <g>
                    <path
                      style={{ fill: "#d13b3b" }}
                      d="M16.53,15.78L7.72,7.04L7.07,7.77l8.69,8.73 M11.07,5.5"
                    />
                  </g>
                </g>
              </svg>
            </div>
            <p className="mb-2 sorry-place-bid-text">Sorry!</p>
          </Card.Title>
          {errorCardMsg?.errorMessage && (
            <>
              <p className="mb-2 tech-error-text">
                {errorCardMsg?.errorMessage}
              </p>
            </>
          )}

          {/*{errorCardMsg?.error_code ===
            "payment_intent_authentication_failure" && (
            <>
              <p className="mb-2 tech-error-text">
                {errorCardMsg?.errorMessage}
              </p>
            </>
          )}
          {errorCardMsg?.error_code === "incorrect_number" && (
            <>
              <p className="mb-2 tech-error-text">
               
                The card number is incorrect. Check the card's number or use a
                different card.
              </p>
            </>
          )} */}
          {/* <div className="technical-error-text mb-4">
            <p className="mb-2 tech-error-text">
              Technical error. Please wait for a few minutes and try again.
            </p>
            <p className="mb-0 tech-error-text">
              If the issue still persists, please reach out to our customer
              support team at (855) 882-1314 .
            </p>
          </div> */}

          <Button
            size="lg"
            onClick={handlegetBidPageDetail}
            className="mt-3 dep-btn-fail"
          >
            Back
          </Button>
        </Card.Body>
      </Card>
    </>
  );
};

export default FailedMsg;
